export default __webpack_public_path__ + "static/media/download-active.d16357b6.svg";